var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsThreeSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_1638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 14.0142C14.7188 14.8426 14.0472 15.5142 13.2188 15.5142C12.3903 15.5142 11.7188 14.8426 11.7188 14.0142C11.7188 13.1857 12.3903 12.5142 13.2188 12.5142C14.0472 12.5142 14.7188 13.1857 14.7188 14.0142Z",
    fill: "#303857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 7.37354C14.7188 8.20196 14.0472 8.87354 13.2188 8.87354C12.3903 8.87354 11.7188 8.20196 11.7188 7.37354C11.7188 6.54511 12.3903 5.87354 13.2188 5.87354C14.0472 5.87354 14.7188 6.54511 14.7188 7.37354Z",
    fill: "#303857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 20.6548C14.7188 21.4832 14.0472 22.1548 13.2188 22.1548C12.3903 22.1548 11.7188 21.4832 11.7188 20.6548C11.7188 19.8264 12.3903 19.1548 13.2188 19.1548C14.0472 19.1548 14.7188 19.8264 14.7188 20.6548Z",
    fill: "#303857"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_1638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "matrix(0 1 1 0 0 0.79541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeSvg);
export default __webpack_public_path__ + "static/media/DotsThreeSVG.0a733583b57c97fd5c3a08351c61841f.svg";
export { ForwardRef as ReactComponent };